import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["id", "status"]
  static values = { url: String }

  disconnect() {
    window.clearTimeout(this.timer)
  }

  schedule() {
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => this.save(), 800)
  }

  save() {
    const data = new FormData(this.element)
    this.element.querySelectorAll("input[type='file']").forEach((input) => data.delete(input.name))
    this.setStatus("Saving draft...")

    fetch(this.urlValue, {
      method: "POST",
      body: data,
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
      }
    }).then((response) => {
      if (!response.ok) throw new Error("Draft save failed")
      return response.json()
    }).then((draft) => {
      this.idTarget.value = draft.id
      this.setStatus("Draft saved")
      this.element.dispatchEvent(new CustomEvent("event-registration-draft:saved", {bubbles: true}))
    }).catch(() => {
      this.setStatus("Draft could not be saved. Keep this form open and try again.")
    })
  }

  setStatus(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }
}
